export default __webpack_public_path__ + "static/media/man.8ff19181.svg";